import React, { useState, useEffect } from "react";
import { Enfants } from "./Enfants";
import { Periodes } from "./Periodes";
import { MontantFrais } from "./MontantFrais";
import { FileUploader } from "./FileUploader";
import { FileUploaderAncv } from "./FileUploaderAncv";
import { CellActivity } from "./CellActivity";
import {Iban} from "./Iban";
import { NoticeActivity } from "./NoticeActivity";
export const FieldBuilder = ({ code, items, onValueChange, disabled ,disabled2 , isIbanValide}) => {

    const getField = (code, items, onValueChange, disabled) => {
        switch (code) {
            case 'NEA_PAC_LCI':
                return (<Enfants enfants={items[0]} enfant={items[1]} onValueChange={onValueChange} disabled={disabled} />);
            case 'NEA_DATE_DEBUT_LCI':
            case 'NEA_DATE_FIN_LCI':
                return (<Periodes type={items[0]} exercice={items[1]} dateRange={items[2]} onValueChange={onValueChange} disabled={disabled} />);
            case 'NEA_MONTANT_FRAIS_LCI':
                return (<MontantFrais label={items[0]} montant={items[1]} min={items[2]} max={items[3]} onValueChange={onValueChange} disabled={disabled} />);
            case 'NEA_JUSTIFICATIF':
                return (<FileUploader mimeTypes={items[0]} categories={items[1]} maxSize={items[2]} multiUpload={items[3]} emptyMsg={items[4]} onValueChange={onValueChange} disabled={disabled} editJustifCategory={items[5]}/>);
            case 'NEA_JUSTIFICATIF_ANCV':
                return (<FileUploaderAncv mimeTypes={items[0]} categories={items[1]} maxSize={items[2]} multiUpload={items[3]} emptyMsg={items[4]} onValueChange={onValueChange} disabled={disabled} editJustifCategory={items[5]}/>);
            case 'NEA_ACTIVITIES':
                return (<CellActivity  products={items[0]} setProducts={items[1]} setMontantTotal={items[2]} exercice={items[3]}  isEnfant={items[4]} selectedEnfant={items[5]} setIncompleteSelectedEnfant={items[6]} setIncompleteActivity={items[7]} />);
            case 'NEA_IBAN_TITULAIRE':
                return (<Iban label={items[0]} iban={items[1]} onValueChange={onValueChange} disabled={disabled} disabled2={disabled2} isIbanValide={isIbanValide}/>);
            case 'NEA_NOTICE_ACTIVITIES':
                return (<NoticeActivity  noticeActivities={items[0]} codeCas={items[1]}/>);
            default:
                return;
        }
    }

    return (
        getField(code, items, onValueChange, disabled)
    );
}
